import { NOT_REQUESTED, REQUESTED, SUCCEEDED, FAILED } from 'forms-utils-lib/RequestState';
import { REQUEST_AD_CONSENT_LABEL, RECEIVE_AD_CONSENT_LABEL, FAIL_RECEIVING_AD_CONSENT_LABEL } from 'FormsUI/actions/AdConsent';
const INIT_STATE = {
  versionId: '',
  text: '',
  requestState: NOT_REQUESTED
};
const AdConsentReducer = (state = INIT_STATE, {
  type,
  adConsent
}) => {
  switch (type) {
    case REQUEST_AD_CONSENT_LABEL:
      return Object.assign({}, INIT_STATE, {
        requestState: REQUESTED
      });
    case RECEIVE_AD_CONSENT_LABEL:
      return {
        versionId: adConsent.versionId,
        text: adConsent.text,
        requestState: SUCCEEDED
      };
    case FAIL_RECEIVING_AD_CONSENT_LABEL:
      return Object.assign({}, INIT_STATE, {
        requestState: FAILED
      });
    default:
      return state;
  }
};
export default AdConsentReducer;